import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Processing() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reportId = searchParams.get("reportId");

  useEffect(() => {
    if (!reportId) {
      navigate("/");
      return undefined;
    }

    const timer = setTimeout(() => {
      navigate(`/report/${reportId}`);
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate, reportId]);

  return (
    <div className="min-h-screen bg-[#FFFBF7] flex items-center justify-center pt-20 md:pt-24">
      <div className="text-center px-4">
        <div className="relative w-24 h-24 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-primary-100" />
          <div className="absolute inset-0 rounded-full border-4 border-primary-400 border-t-transparent animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center">
            <i className="ri-brain-line text-primary-400 text-2xl" />
          </div>
        </div>
        <h2 className="text-xl md:text-2xl font-bold text-navy-400 mb-3">
          {t("processingTitle")}
        </h2>
        <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto leading-relaxed">
          {t("processingSubtitle")}
        </p>
        <div className="mt-8 flex justify-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary-400 animate-bounce" style={{ animationDelay: "0ms" }} />
          <div className="w-2 h-2 rounded-full bg-primary-400 animate-bounce" style={{ animationDelay: "150ms" }} />
          <div className="w-2 h-2 rounded-full bg-primary-400 animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      </div>
    </div>
  );
}
